import fetchData from 'src/services/api';
import { auth } from 'src/utils/firebase';

// Console CLI utilities for debugging and development
const initConsoleCommands = () => {
  if (process.env.NODE_ENV !== 'development') return;

  window.__PLAID__ = {
    // Sync all data for current user
    sync: async () => {
      try {
        const uid = auth.currentUser?.uid;
        if (!uid) throw new Error('No user found');
        await fetchData(`/api/providers/sync/${uid}`);
        console.log('✅ Sync completed');
      } catch (error) {
        console.error('❌ Sync failed:', error);
        throw error;
      }
    },

    // Sync specific data types
    syncAccounts: async () => {
      try {
        const uid = auth.currentUser?.uid;
        if (!uid) throw new Error('No user found');
        await fetchData(`/api/providers/sync/${uid}`);
        console.log('✅ Accounts sync completed');
      } catch (error) {
        console.error('❌ Accounts sync failed:', error);
        throw error;
      }
    },

    // Add more utility functions as needed
    help: () => {
      console.log(`
Available Plaid Console Commands:
--------------------------------
window.__PLAID__.sync()          - Sync all Plaid data
window.__PLAID__.syncAccounts()  - Sync only accounts
window.__PLAID__.help()          - Show this help message
      `);
    },
  };

  // console.log(
  //   '🔧 Plaid console utilities loaded. Type window.__PLAID__.help() for available commands'
  // );
};

export default initConsoleCommands;
